import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { McticHttpClient } from '@mctic/ng-core';

@Injectable({
  providedIn: 'root'
})

export class ValidaRdaService {

  private readonly endpoint = '/sepin-backend/rest/rda';

  constructor(
    private readonly http: McticHttpClient,
    private readonly httpClient: HttpClient) {
  }

  validarRda() {
    return this.http.get(`${this.endpoint}/validar`);
  }

  visualizar() {
    const headers = new HttpHeaders();
    headers.append('Accept', 'application/pdf');
    return this.httpClient.get(`${this.endpoint}/visualizar`, {headers, observe: 'response', responseType: 'arraybuffer'});
  }
}
